module.exports = __webpack_public_path__ + "static/media/logo.a1f97ab1.png";